var _defs, _path, _path2, _rect, _path3, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgIcebergAnimal8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 86 117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00cdda;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bg-iceberg-animal8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-1",
    d: "M57,43.82a12.69,12.69,0,1,1,15.7-8.7A12.7,12.7,0,0,1,57,43.82Zm5.6-19.52a7.62,7.62,0,1,0,5.22,9.42,7.62,7.62,0,0,0-5.22-9.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    className: "cls-1",
    d: "M35.9,115.41C14.41,109.25,1.89,87,8,65.74a2.47,2.47,0,0,1,4.75,1.36c-5.35,18.64,5.66,38.21,24.52,43.62a35.43,35.43,0,0,0,43.92-24,2.47,2.47,0,0,1,4.75,1.36c-6.09,21.22-28.52,33.48-50,27.32Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    className: "cls-1",
    x: 9.77,
    y: 75.08,
    width: 75,
    height: 5,
    transform: "translate(-40.33 101.63) rotate(-74)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    className: "cls-1",
    d: "M45.09,52.5a2.5,2.5,0,1,1,1.38-4.8l17.31,5a2.5,2.5,0,0,1-1.37,4.81l-17.32-5Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval-1",
    className: "cls-1",
    cx: 5.39,
    cy: 24.42,
    r: 3.33
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval-1-2",
    "data-name": "Oval-1",
    className: "cls-1",
    cx: 28.7,
    cy: 11.1,
    r: 2.22
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval-1-3",
    "data-name": "Oval-1",
    className: "cls-1",
    cx: 13.16,
    cy: 2.22,
    r: 2.22
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgIcebergAnimal8);
export default __webpack_public_path__ + "static/media/bg-iceberg-animal8.870bf4cfba99fb7903d4d5fa8d1968fa.svg";
export { ForwardRef as ReactComponent };